import {isPresent} from "../../helpers/object";

export default class Experience {

    constructor(props={}, experienceMarker=null, onlineApp=null) {
        this.experienceMarker = experienceMarker;
        this.onlineApp = onlineApp;

        this.id = props.id;
        this.code = props.code;

        this.primaryName = props.primary_name;

        this.commercial = props.commercial;
        this.hasBenefits = props.has_benefits;
        this.monetizable = props.monetizable;

        this.url = props.url;
        this.slug = props.slug;

        this.markerUrl = props.marker_url;

        this.rankingScore = props.ranking_score;
        this.rankingsCount = props.rankings_count;

        this.regionCode = props.region_code;

        this.analyticsIdentifer = `${ this.code || this.id }`;
        this.analyticsParameters = props.analytics_parameters;
    }

    getAnalyticsParameters() {
        // The item_id is used as a safety net because GA4 doesn't like custom parameters (like `experience_id`) to have too many possible values. *Hopefully* item_id doesn't have the same limitations.
        const fallbackParameters = { experience_id: this.analyticsIdentifer, item_id: this.analyticsIdentifer }; // The fallback parameters are essentially backwards compatible with old experiences.json API data which doesn't include the "analytics_parameters" key.
        return isPresent(this.analyticsParameters) ? this.analyticsParameters : fallbackParameters;
    }

}
